// extracted by mini-css-extract-plugin
export default {"cardsContainer":"discovery_cardsContainer__yPCeC","chartContainer":"discovery_chartContainer__+sx3u","slide-in-bottom":"discovery_slide-in-bottom__jCr1m"};